/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function logError(error: any, info: any) {
	console.log('Logging to my service');
	console.log(error);
}
